export function useUser() {
    const config = useRuntimeConfig()

    const getToken = async () => {
        const { getToken } = useGetToken()
        return await getToken()
    }

    const isUserLoggedIn = async () => {
        return !!(await getToken())
    }

    const logOut = async (redirectUrl = `${config.public.siteUrl}${config.public.loginUrl}`) => {
        const { onLogout } = useApollo()
        await onLogout()
        window.location.href = redirectUrl
    }

    return {
        getToken,
        isUserLoggedIn,
        logOut,
    }
}
